// extracted by mini-css-extract-plugin
export default {"stake_container":"styles_stake_container__0fj9W","stake_cards_container":"styles_stake_cards_container__u-fDl","tabs":"styles_tabs__3I+pZ","appear":"styles_appear__yN2Sd"};